import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import es from "./locales/es.json";
import en from "./locales/en.json";
import de from "./locales/de.json";

export const SUPPORTED_LANGUAGES = ["es", "en", "de"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  es: "Español",
  en: "English",
  de: "Deutsch",
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      de: { translation: de },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    // Resolve by language part only, so a browser locale like "en-US" or
    // "de-AT" maps to the supported base language ("en" / "de") instead of
    // failing the supportedLngs check and silently falling back to "es".
    // This is what makes a first open on an English/German device open in
    // that language; "es" is only used when nothing detectable matches.
    load: "languageOnly",
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      // Check localStorage first, then browser/device language.
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "app_language",
      caches: ["localStorage"],
    },
  });

export default i18n;
